function Treasury() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33331 13.332H14.6666V14.6654H1.33331V13.332ZM2.66665 7.9987H3.99998V12.6654H2.66665V7.9987ZM5.99998 7.9987H7.33331V12.6654H5.99998V7.9987ZM8.66665 7.9987H9.99998V12.6654H8.66665V7.9987ZM12 7.9987H13.3333V12.6654H12V7.9987ZM1.33331 4.66536L7.99998 1.33203L14.6666 4.66536V7.33203H1.33331V4.66536ZM2.66665 5.48936V5.9987H13.3333V5.48936L7.99998 2.8227L2.66665 5.48936ZM7.99998 5.33203C7.82317 5.33203 7.6536 5.26179 7.52858 5.13677C7.40355 5.01174 7.33331 4.84218 7.33331 4.66536C7.33331 4.48855 7.40355 4.31898 7.52858 4.19396C7.6536 4.06894 7.82317 3.9987 7.99998 3.9987C8.17679 3.9987 8.34636 4.06894 8.47138 4.19396C8.59641 4.31898 8.66665 4.48855 8.66665 4.66536C8.66665 4.84218 8.59641 5.01174 8.47138 5.13677C8.34636 5.26179 8.17679 5.33203 7.99998 5.33203Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Treasury;
